<template>
    <div class="activity-content auto-rebalance-disabled">
        <div class="activity-header">
            <span class="material-icons disabled-icon">block</span>
            <div class="activity-title">Otomatik Bakiye Yükleme Devre Dışı</div>
        </div>
        <div class="activity-details">
            <div class="detail-item">
                <span class="label">Sebep:</span>
                <span class="value error">Çok fazla başarısız deneme</span>
            </div>
            <div class="detail-item">
                <span class="label">Son Hata:</span>
                <span class="value">{{ activity.payload.error }}</span>
            </div>
            <div class="detail-item">
                <span class="label">Başarısız Deneme:</span>
                <span class="value">{{ activity.payload.failedAttempts }}/{{ activity.payload.maxFailedAttempts }}</span>
            </div>
            <div class="detail-item">
                <span class="label">Eşik Değer:</span>
                <span class="value">{{ formatPrice(activity.payload.threshold) }} TL</span>
            </div>
            <div class="detail-item">
                <span class="label">Hedef Bakiye:</span>
                <span class="value">{{ formatPrice(activity.payload.upTo) }} TL</span>
            </div>
        </div>
        <div class="activity-footer">
            <span class="critical-text">
                <span class="material-icons">warning</span>
                Otomatik yükleme özelliği devre dışı bırakıldı. Panel ayarlarından kontrol edin ve yeniden etkinleştirin.
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "AutoRebalanceDisabled",
    props: {
        activity: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatPrice(price) {
            if (!price) return "0.00";
            return price.toFixed(2);
        },
    },
};
</script>

<style scoped lang="scss">
.auto-rebalance-disabled {
    .activity-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;

        .disabled-icon {
            color: #ff4d4f;
            font-size: 20px;
        }

        .activity-title {
            font-weight: 600;
            color: #ff4d4f;
            font-size: 14px;
        }
    }

    .activity-details {
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding-left: 28px;
        margin-bottom: 12px;

        .detail-item {
            display: flex;
            justify-content: space-between;
            font-size: 13px;

            .label {
                color: #666;
            }

            .value {
                font-weight: 500;
                color: #333;

                &.error {
                    color: #ff4d4f;
                    font-weight: 600;
                }
            }
        }
    }

    .activity-footer {
        padding-left: 28px;

        .critical-text {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
            color: #ff4d4f;
            background: #fff2f0;
            padding: 8px 12px;
            border-radius: 4px;
            border: 1px solid #ffccc7;

            .material-icons {
                font-size: 16px;
            }
        }
    }
}
</style>
